<template>
  <div class="media-upload-item">
    <div class="sample" v-if="!hasStarted" @click="uploadPic">
      <slot></slot>
    </div>
    <div
      class="preview"
      v-if="hasStarted"
      :style="{ backgroundImage: 'url(' + $setPicSize(imagePreview) + ')' }"
    ></div>
    <div class="progress-state" v-show="isUploading">
      <span>正在上传...</span>
    </div>
    <img class="close-btn" v-show="hasEnded" src="../images/close.png" @click="deletePic" />
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import { lego } from '@zz-common/lego'
import { toast } from '../../../native'
import { getCookie, isCheckApp, isHunterApp } from '../../../lib/utils'

//  文件上传状态
const fileUploadState = {
  NOT_STARTED: 0,
  UPLOADING: 1,
  ENDED: 2
}
let maxRequestID = 1

export default {
  name: 'SecurePicUploadItem',
  props: {
    type: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imagePreview: '',
      progress: 0,
      uploadState: fileUploadState.NOT_STARTED
    }
  },
  computed: {
    hasStarted() {
      return (
        this.uploadState === fileUploadState.UPLOADING ||
          this.uploadState === fileUploadState.ENDED
      )
    },
    isUploading() {
      return this.uploadState === fileUploadState.UPLOADING
    },
    hasEnded() {
      return this.uploadState === fileUploadState.ENDED
    },
    isFront() {
      if (this.type === 'front') {
        return '1'
      }
      return '0'
    }
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 444, 444)
    },
    uploadPic() {
      if (this.uploadState === fileUploadState.UPLOADING) return

      lego.send({
        pagetype: 'ZZUP_REALAUTH_COMMITINFO',
        actiontype: 'UPLOAD_IDCARD_CLICK',
        backup: {
          cardtype: this.type
        }
      })

      let startTime = 0
      const requestID = maxRequestID++

      this.imagePreview = ''
      this.progress = 0
      this.uploadState = fileUploadState.NOT_STARTED

      let invokeIDCardCamera = null
      const zzv = getCookie('v')
      const zzver = zzv && zzv.split('.')
      if ((zzver && zzver[0] >= 5) || isCheckApp || isHunterApp) {
        invokeIDCardCamera = native.wrap('takePhotoOfIDCard')
      } else {
        invokeIDCardCamera = native.wrap('getSystemCamera')
      }

      invokeIDCardCamera(
        {
          requestid: requestID,
          compressQuality: native.in('zz') ? '0.5' : '0.9',
          compressWidth: native.in('zz') ? 800 : '',
          isFront: this.isFront,
          //type: '1',
          tip: this.tip || (this.isFront === '1'
            ? '将证件人像面置于此区域，拍摄身份证'
            : '将证件国徽面置于此区域，拍摄身份证')
        },
        (res) => {
          if (!(res && res.code)) return

          if (res.code === '0') {
            if (Number(res.requestId) !== Number(requestID)) return

            this.progress = res.progress
            if (this.uploadState !== fileUploadState.UPLOADING) {
              this.uploadState = fileUploadState.UPLOADING
              startTime = Date.now()
            }

            if (res.photoBase64) {
              this.imagePreview = res.photoBase64
            }
            if (res.photoString) {
              console.info(res.photoString)

              this.uploadState = fileUploadState.ENDED
              this.$emit('uploaded', res.photoString, startTime)
            }
          } else {
            this.imagePreview = ''
            this.progress = 0
            this.uploadState = fileUploadState.NOT_STARTED
            console.warn(res.msg || '调起拍照失败')
            toast({
              msg: res.msg || '调起拍照失败',
              style: '2'
            })
          }
        }
      )
    },
    deletePic() {
      this.imagePreview = ''
      this.progress = 0
      this.uploadState = fileUploadState.NOT_STARTED
      this.$emit('uploaded', '')
    }
  }
}
</script>

<style scoped lang="less">
  @import 'MediaUploadItem.less';
</style>
